"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _fill = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/fill"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _styles = require("./styles");
const propTypes = {
  maxAvailabilitiesToDisplay: _propTypes.number.isRequired,
  shouldDisplayAsOnMobile: _propTypes.bool,
  compactTiles: _propTypes.bool,
  compactHeight: _propTypes.number,
  /** Determines the minium tile width */
  tileSize: (0, _propTypes.oneOf)(['small', 'large'])
};
const defaultProps = {
  shouldDisplayAsOnMobile: false,
  compactTiles: false,
  compactHeight: 60,
  tileSize: 'large'
};
const LoadingAvailabilityTiles = _ref => {
  var _context, _context2;
  let {
    maxAvailabilitiesToDisplay,
    shouldDisplayAsOnMobile,
    compactTiles,
    compactHeight,
    tileSize
  } = _ref;
  const Shimmer = compactTiles ? _styles.ShimmeringCompactSlot : _styles.ShimmeringSlot;
  const shimmeringSlots = (0, _map.default)(_context = (0, _fill.default)(_context2 = Array(maxAvailabilitiesToDisplay)).call(_context2)).call(_context, (_s, i) => /*#__PURE__*/_react.default.createElement(Shimmer, {
    key: i,
    as: "div",
    shouldDisplayAsOnMobile: shouldDisplayAsOnMobile,
    style: {
      height: compactTiles ? compactHeight : undefined
    },
    tileSize: tileSize
  }));
  const LoadingContainer = compactTiles ? _styles.CompactTilesContainer : _styles.FlexContainer;
  return /*#__PURE__*/_react.default.createElement(LoadingContainer, {
    "data-testid": "AvailabilityTiles__Loading",
    shouldDisplayAsOnMobile: shouldDisplayAsOnMobile,
    tileSize: tileSize
  }, shimmeringSlots);
};
LoadingAvailabilityTiles.propTypes = propTypes;
LoadingAvailabilityTiles.defaultProps = defaultProps;
var _default = exports.default = LoadingAvailabilityTiles;
LoadingAvailabilityTiles.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LoadingAvailabilityTiles",
  "props": {
    "shouldDisplayAsOnMobile": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "compactTiles": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "compactHeight": {
      "defaultValue": {
        "value": "60",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "tileSize": {
      "defaultValue": {
        "value": "'large'",
        "computed": false
      },
      "description": "Determines the minium tile width",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false
    },
    "maxAvailabilitiesToDisplay": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    }
  }
};